<script context="module">
    import { selectedItem } from '../../store/store.js';
</script>

<div class="key-value-table box">
    <div class="header-card">
        <h5><i class="fa-solid fa-building fa-xs icon-prefix"></i> Företagsinformation</h5>
    </div>

    <div class="info-grid">
        <!-- Organisationsnummer -->
        <div class="info-card">
            <div class="info-header">
                <i class="fa-solid fa-id-card-clip fa-sm icon-detail"></i>
                <h6>Organisationsnummer</h6>
            </div>
            <div class="info-value">{$selectedItem.org_number}</div>
        </div>

        <!-- Föreningen bildad datum -->
        {#if $selectedItem.registry_date}
            <div class="info-card">
                <div class="info-header">
                    <i class="fa-solid fa-calendar-days fa-sm icon-detail"></i>
                    <h6>Föreningen bildad</h6>
                </div>
                <div class="info-value">
                    {new Date($selectedItem.registry_date).toISOString().split('T')[0]}
                </div>
            </div>
        {/if}

        <!-- Status -->
        <div class="info-card">
            <div class="info-header">
                <i class="fa-solid fa-signal fa-sm icon-detail"></i>
                <h6>Status</h6>
            </div>
            <div class="info-value status">
                {#if $selectedItem.status === null || $selectedItem.status === undefined}
                    <span class="status-unknown">Okänd</span>
                {:else if $selectedItem.status === 1}
                    <span class="status-active">Aktiv</span>
                {:else}
                    <span class="status-inactive">Ej aktiv</span>
                {/if}
            </div>
        </div>
    </div>

    <!-- Verksamhet & ändamål -->
    {#if $selectedItem.about}
        <div class="info-card full-width">
            <div class="info-header">
                <i class="fa-solid fa-bullseye fa-sm icon-detail"></i>
                <h6>Verksamhet & ändamål</h6>
            </div>
            <div class="info-value" style="font-weight: 100; font-size: 0.9rem;">
                <p>{$selectedItem.about}</p>
            </div>
        </div>
    {/if}

    <!-- Adresser -->
    {#if $selectedItem?.addresses?.length > 0}
        <div class="info-card full-width">
            <div class="info-header">
                <i class="fa-solid fa-map-location-dot fa-sm icon-detail"></i>
                <h6>Adresser</h6>
            </div>
            <div class="info-content">
                <ul class="address-list">
                    {#each $selectedItem.addresses as adress}
                        <li>{adress}</li>
                    {/each}
                </ul>
            </div>
        </div>
    {/if}
</div>

<style>

    .info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 20px;
        margin-bottom: 25px;
    }

    .info-card {
        background-color: #f8f9fa;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        transition: transform 0.2s, box-shadow 0.2s;
        border: 1px solid #e9ecef;
    }

    .info-card.full-width {
        grid-column: 1 / -1;
        margin-top: 0;
    }
    .info-card.full-width + .info-card.full-width {
        margin-top: 20px;
    }

    .info-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    }

    .info-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }

    .info-header h6 {
        font-size: 0.9rem;
        color: #495057;
        font-weight: 500;
    }

    .info-value {
        font-size: 1.1rem;
        font-weight: 600;
        color: var(--box-title-color);
        text-align: left;
    }

    .info-value.status span {
        padding: 3px 8px;
        border-radius: 6px;
        font-size: 0.9rem;
        font-weight: 500;
    }
    .status-active {
        background-color: rgba(40, 167, 69, 0.1);
        color: #1a6e2c;
    }
    .status-inactive {
        background-color: rgba(220, 53, 69, 0.1);
        color: #8b212d;
    }
    .status-unknown {
        background-color: rgba(108, 117, 125, 0.1);
        color: #495057;
    }

    .info-content {
        font-size: 0.95rem;
        color: #343a40;
        line-height: 1.7;
    }

    .address-list {
        list-style: none;
        padding-left: 0;
        margin: 0;
    }

    .address-list li {
        margin-bottom: 8px;
        position: relative;
        text-align: left;
    }
    .address-list li:last-child {
        margin-bottom: 0;
    }
</style>